module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-12\">\n      <footer>\n        Copyright &copy; {{year}} Francis Li<br />\n        https://www.francisli.com/\n      </footer>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer.component.html
// module id = 208
// module chunks = 1